import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const guidelinesApiService = createApi({
    reducerPath: 'guidelinesApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/guideline/'),
    endpoints: (builder) => ({
        getGuidelines: builder.query({
            query: (args) => {
                let { id } = args

                if (id) {
                    return `get/${id}`
                }

                let query = queryParams(args)

                return `get${query}`
            },
            keepUnusedDataFor: 0
        }),
        createGuideline: builder.mutation({
            query: (body) => ({
                url: `create`,
                method: "POST",
                body
            })
        }),
        deleteGuideline: builder.mutation({
            query: (id) => ({
                url: `delete/${id}`,
                method: "DELETE"
            })
        }),
        updateGuideline: builder.mutation({
            query: (body) => ({
                url: `update/${body?._id}`,
                method: "PUT",
                body
            })
        })
    })
})

export const {
    useGetGuidelinesQuery,
    useCreateGuidelineMutation,
    useDeleteGuidelineMutation,
    useUpdateGuidelineMutation
} = guidelinesApiService
